import { MODULE_KEY } from '@/constants/modules';
import { useWorkspaceAssistantConfigurationQuery } from './useAssistantConfiguration';
import { useHasTenantPermission } from './useHasTenantPermission';
import { useHasWorkspaceModule } from './useHasWorkspaceModule';

export const ASSISTANT_CONFIGURE_PERMISSION = 'assistant.configure';

export function useCanCustomizeAssistant(isWorkspaceOwner: boolean): boolean {
  const hasModule = useHasWorkspaceModule(MODULE_KEY.aiAssistant);
  const hasPermission = useHasTenantPermission(ASSISTANT_CONFIGURE_PERMISSION);
  const configurationQuery = useWorkspaceAssistantConfigurationQuery(
    hasModule && hasPermission && isWorkspaceOwner
  );
  return configurationQuery.data !== undefined && configurationQuery.data.canCustomize;
}
